module.exports = __webpack_public_path__ + "static/media/home_insurance_icon.6ece9f23.svg";